module.exports = __webpack_public_path__ + "static/img/14.8220dca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/zh/14.png
// module id = FfNb
// module chunks = 0